import { HRMUserEngagementTimeSheetDTO } from '@/models';
import { forEach, keyBy, pick } from 'lodash';

const separateKey = '&';

export const generateHrmTimeSheetKey = (data: HRMUserEngagementTimeSheetDTO): string => {
  const { periodEndDate, task, activityName, user, projectName } = data;
  return [periodEndDate, task, activityName, user, projectName].join(separateKey);
};

const acceptedFields = ['isApproved', 'note', 'totalHourTask'];
export const remapHrmTimeSheets = (
  source: HRMUserEngagementTimeSheetDTO[],
  editedSource: HRMUserEngagementTimeSheetDTO[]
): HRMUserEngagementTimeSheetDTO[] => {
  const sourceMap = keyBy(source, generateHrmTimeSheetKey);
  const editedSourceMap = keyBy(editedSource, generateHrmTimeSheetKey);

  forEach(editedSourceMap, (value, key) => {
    sourceMap[key] = {
      ...(sourceMap[key] ? sourceMap[key] : value),
      ...pick(value, acceptedFields),
      totalHourTaskOriginal: value?.totalHourTask
    };
  });
  return Object.values(sourceMap);
};
